"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasKey = void 0;
// hasKey with type assertion: If the check is successful, TypeScript will then allow to call x[key].
// Optionally, you can specify the type of x[key] as second type parameter.
// eslint-disable-next-line @typescript-eslint/ban-types
var hasKey = function (x, key) { return key in x; };
exports.hasKey = hasKey;
